
////////////////////////////////////
// M066 image text columns

function initImageTextColumns(){
    
	if($(".imageTextColumns").length > 0){
		
	}
}
